import { SupportedThemes, Theme } from '../../core/tokens/services/theme.service';
import { TextToken } from '../../core/tokens/types';

type AvatarSpecificTokenExtract<T> = Extract<T, `colorAvatar${string}`>;
type ExtractedAvatarToken = AvatarSpecificTokenExtract<keyof Theme>;

export type AvatarToken = ExtractedAvatarToken extends never
  ? AvatarSpecificTokenExtract<keyof typeof SupportedThemes.light>
  : ExtractedAvatarToken;

export type AvatarsTokens = {
  backgroundColor: AvatarToken;
  color: TextToken;
};

export const avatarTokenSet: AvatarsTokens[] = [
  {
    backgroundColor: 'colorAvatarSteelLighter',
    color: 'colorTextOnprimaryDefault',
  },
  {
    backgroundColor: 'colorAvatarSteelLight',
    color: 'colorTextOnprimaryDefault',
  },
  {
    backgroundColor: 'colorAvatarSteelDark',
    color: 'colorTextOnprimaryDefault',
  },

  {
    backgroundColor: 'colorAvatarGreen',
    color: 'colorTextOncomponentDefault',
  },
  {
    backgroundColor: 'colorAvatarBlueLight',
    color: 'colorTextOncomponentDefault',
  },
  {
    backgroundColor: 'colorAvatarBlueDark',
    color: 'colorTextOncomponentDefault',
  },
  {
    backgroundColor: 'colorAvatarPink',
    color: 'colorTextOncomponentDefault',
  },
  {
    backgroundColor: 'colorAvatarPurple',
    color: 'colorTextOncomponentDefault',
  },
  {
    backgroundColor: 'colorAvatarYellow',
    color: 'colorTextOncomponentDefault',
  },
  {
    backgroundColor: 'colorAvatarOrange',
    color: 'colorTextOncomponentDefault',
  },
];
